import { Skeleton } from '@components/skeleton/index';

import { SkeletonRow } from '.';

export const OffersDialogueButtonSkeleton = () => (
  <Skeleton className='h-[44px] rounded-4xl bg-gray-200 md:w-[180px]'>
    <SkeletonRow />
  </Skeleton>
);
